module.exports = {
    devPath: '//localhost',
    publicPath: '',
    // publicPath: '',
}
